<div class="modal-header bg-dark text-white">
  <h4 class="modal-title" id="modal-basic-title">Ship settings: MMSI {{data.info.id}}</h4>
  <div id="close-sidebar" (click)="activeModal.dismiss('Cross click')">
    <fa-icon [fixedWidth]="true" icon="times"></fa-icon>
  </div>
</div>
<div class="modal-body bg-dark text-white custom-slider">
  <p>
    <fa-icon [fixedWidth]="true" icon="info-circle"></fa-icon>
    <a [href]="data?.info?.url" class="ml-3 text-white" target="_blank">{{data?.info?.url}}</a>
  </p>
  <div class="row">
    <div class="col-6 text-black-50">
      <app-color-picker [color]="mapParams.markerColor" [heading]="'Marker Color'"
                        (event)="setValue('markerColor', $event)"></app-color-picker>
    </div>
    <div class="col-6 text-black-50">
      <app-color-picker [color]="mapParams.trackColor" [heading]="'Track Color'"
                        (event)="setValue('trackColor', $event)"></app-color-picker>
    </div>
  </div>
  <label>Marker Size</label>
  <ngx-slider
    [value]="mapParams.markerSize"
    (userChangeEnd)="setValue('markerSize', $event)"
    [options]="sliderOption"></ngx-slider>
  <label>Track Width</label>
  <ngx-slider
    [value]="mapParams.trackWidth"
    (userChangeEnd)="setValue('trackWidth', $event)"
    [options]="sliderOption"></ngx-slider>
</div>
<div class="modal-footer bg-dark text-white">
  <button type="button" class="btn btn-primary" (click)="save()">Save</button>
</div>
